const LINKTREE_CDN_HOSTS = ['linktr.ee']

const ATTACHMENT_IMAGE_SIZE_PRESET = 'messaging-attachment-v1_0'

function hostnameFromUrl(url: string): string | null {
  try {
    return new URL(url).hostname.toLowerCase()
  } catch {
    return null
  }
}

function isLinktreeCdnHost(hostname: string): boolean {
  return LINKTREE_CDN_HOSTS.some(
    (host) => hostname === host || hostname.endsWith(`.${host}`)
  )
}

export function optimizeMessagingAttachmentUrl(
  url: string | undefined | null
): string | undefined {
  const trimmed = url?.trim()
  if (!trimmed) return undefined

  const hostname = hostnameFromUrl(trimmed)
  if (!hostname || !isLinktreeCdnHost(hostname)) return trimmed

  const parsedUrl = new URL(trimmed)
  const isAlreadyMessagingOptimized =
    parsedUrl.searchParams.get('io') === 'true' &&
    parsedUrl.searchParams.get('size') === ATTACHMENT_IMAGE_SIZE_PRESET

  if (isAlreadyMessagingOptimized) {
    return trimmed
  }

  parsedUrl.searchParams.set('io', 'true')
  parsedUrl.searchParams.set('size', ATTACHMENT_IMAGE_SIZE_PRESET)

  return parsedUrl.toString()
}
